var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pdf-gen',{ref:"invoice",attrs:{"header-data":Array(_vm.pdf_header),"page-margins":[15, 110, 15, 60],"footer-data":Array(_vm.pdf_footer),"content-data":Array(_vm.pdf_content),"name":_vm.data['bill_number'] + ' ' + _vm.data.project.name + ' Vk ' + _vm.weeks}})
}
var staticRenderFns = []

export { render, staticRenderFns }